import { useSelector } from "react-redux"
import { Grid } from "@material-ui/core"
import Album from "./album/album.js";


const Albums = () =>
{


  const albums = useSelector((state) => state.albums);

  /**
   * The reason for parentheses being used is because of jsx
   * and the nature of the return statement
   */

  return (
    !albums.length
      ? (
        <div/>
      )
      : (
        <Grid container>
          {albums.map((album) => (
            <Grid key={album._id} item xs={12} md={4} lg={4} xl={3}>
              <Album album={album} />
            </Grid>
          ))}
        </Grid>
      )
  );
}

export default Albums;